export enum ButtonVariant {
	Primary = "Primary",
	Outline = "Outline",
	Pill = "Pill",
	PillActive = "PillActive",
}

export enum ButtonSize {
	Sm = "Sm",
	Base = "Base",
}

// TODO sizes of buttons

export function getButtonClass(variant: ButtonVariant, size?: ButtonSize): string {
	const commonClasses =
		"inline-block tracking-[0.01em] border-2 text-center shadow-2xs leading-tight rounded-full max-w-[28.75rem] w-fit font-bold cursor-pointer";

	const sizeBaseClasses = "md:px-8 px-6 py-3.5 min-w-[16.5rem] text-base";

	const sizeSmClasses = "text-sm py-2 px-4";

	const pillClasses =
		"border-white transition-color duration-200 transition-background transition-all rounded-lg font-bold py-3.5 px-6";

	switch (variant) {
		case ButtonVariant.Primary:
			return `${size === ButtonSize.Sm ? sizeSmClasses : sizeBaseClasses} ${commonClasses} border-green btn-primary-animation text-white bg-green hover:bg-green transition-all duration-200 ease-in-out`;
		case ButtonVariant.Outline:
			return `${size === ButtonSize.Sm ? sizeSmClasses : sizeBaseClasses} ${commonClasses} border-blue-animation transition-color  duration-200 hover:text-blue-animation transition-background bg-white/50 hover:bg-white text-blue transition-all`;

		case ButtonVariant.Pill:
			return `${pillClasses} bg-white text-lightblue`;

		case ButtonVariant.PillActive:
			return `${pillClasses} bg-blue text-green`;
	}
}
